///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promo = abcsetup.promo || {};
abcsetup.promo.create = abcsetup.promo.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promo.create = {
    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function()  {
        if (abcsetup.userRole.class == 'gnp_promo_team') {
            abcsetup.promos.gnp.common.init();
        } else {
            abcsetup.promos.common.init();
        }
    },
}